// import safeEval from 'safe-eval';
import ObjectIdLib from 'bson-objectid';

export default function({
    PARAMETER={}, VARIABLE={}, inputText='',
    Moment, moment
}){
    const ObjectId = ObjectIdLib;
    let value;
    try{
        let expression = inputText.trim().startsWith('{') 
            ? '(' + inputText + ')' 
            : inputText;
        value = eval(expression);
        PARAMETER = null;
        VARIABLE = null;
        inputText = null;
        Moment = null;
        moment = null;
        return value;
    }catch(e){
        console.log('functionParser eval', e.message, inputText);
        if(
            (
                e.message.toLowerCase().includes("unexpected token") ||
                e.message.toLowerCase().includes("expected expression")
            ) && 
            (e.message.includes("':'") || e.message.includes("'...'"))
        ){
            try{
                value = eval('(' + inputText + ')');
                PARAMETER = null;
                VARIABLE = null;
                inputText = null;
                Moment = null;
                moment = null;
                return value;
            }catch(err){
                console.log('FunctionParser eval (TWO)', err.message, inputText);
                PARAMETER = null;
                VARIABLE = null;
                inputText = null;
                Moment = null;
                moment = null;
                value = null;
                throw err;
            }
        }else{
            PARAMETER = null;
            VARIABLE = null;
            inputText = null;
            Moment = null;
            moment = null;
            value = null;
            throw e;
        }
    }
}